import { render, staticRenderFns } from "./AsociarnotasCredito.vue?vue&type=template&id=82f0c31a"
import script from "./AsociarnotasCredito.vue?vue&type=script&lang=js"
export * from "./AsociarnotasCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports